import React, { useState, useEffect } from "react"
import {
    Row,
    Col,
    Input,
    Table,
    Label,
} from "reactstrap"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { get } from "helpers/api_helper"
import { GET_INVOICE_DETAILS } from "helpers/url_helper"
import { Spin } from "antd"
import moment from "moment";
const InvoiceDetails = props => {
    const [isLoading, setIsLoading] = useState(false)
    const [details, setDetails] = useState(null)
    const [ID, setID] = useState("")
    const { setHide, id, data} = props

    const getData = async () => {
        setIsLoading(true)
        setID(id)
        get(`${GET_INVOICE_DETAILS}/${id}`)
            .then(res => {
                if (res?.status === 200) {
                    setDetails(res?.data)
                     
                } else {
                    setDetails(null)
                }
                setIsLoading(false)
            })
            .catch(error => {
                 
                setIsLoading(false)
            })
        
    }

    const getInvoiceDetail = id => {
        setIsLoading(true);
        get(GET_INVOICE_DETAILS + `/${id}`).then(res => {
          if (res.status === 200) { 
            setDetails(res?.data)
          }
          setIsLoading(false);
        })
      }

    useEffect(() => {
        getData()
    }, [])


    return (
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
            <Row>
                <Col
                    lg={3}
                    md={3}
                    sm={3}
                    style={{
                        height: "100%",
                    }}
                >
                    <Row style={{ background: "#f0f0f0", marginLeft: "-25px" }}>

                        <Col
                            lg={12}
                            md={12}
                            sm={12}
                            style={{
                                borderTop: "1px solid #cacaca",
                            }}
                        >
                            {data?.map((x, i) => (
                            <Row  
                            style={{
                                marginBottom: "5px",
                                marginTop: "5px",
                                backgroundColor: x?.invoice?.id === ID ? "#cecece96" : "",
                                cursor: "pointer",
                              }}
                            onClick={() => {
                              setID(x?.invoice?.id)
                              getInvoiceDetail(x?.invoice?.id)
                            }}
                            >
                                <div className="col-1 col-lg-1 col-md-1 col-sm-2">
                                    {" "}
                                    <Input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="check"
                                        checked={false}
                                    />
                                </div>
                                <div className="col col-lg-6 col-md-6 col-sm-6">
                                    <text>{x.contact.display_name}</text>
                                    <br></br>
                                    <div style={{ fontSize: "10px", marginTop: "6px" }}>
                                        <Link to="#">{x.invoice?.invoice_no}</Link> | {x.invoice?.invoice_date ? moment(x.invoice.invoice_date).format("DD-MMM-YYYY").replace(/^\-/, "") : ""}
                                    </div>
                                </div>
                                <div
                                    className="col col-lg-5 col-md-5 col-sm-4"
                                    style={{
                                        marginLeft: "-2px",
                                        textAlign: "end",
                                        padding: "0.05rem 0.5rem",
                                    }}
                                >
                                    <text>Rs. {x.invoice?.grand_total}</text>
                                    <br></br>
                                    <text style={{ fontSize: "10px", color: "grey" }}>
                                    {x.invoice?.invoice_status}
                                    </text>
                                </div>
                            </Row>
                            ))}
                        </Col>
                    </Row>
                </Col>

                <Col
                    lg={9}
                    md={9}
                    sm={9}
                    style={{ borderLeft: "1px solid #cacaca" }}
                >
                    <Row>
                        <Col
                            lg={12}
                            style={{
                                marginTop: "20px",
                            }}
                        >
                            <div style={{ fontSize: "16px", color: "grey" }}>
                            {details?.contact.display_name}
                            </div>
                            <div style={{ textAlignLast: "end" }}>
                                <button
                                    type="button"
                                    className="btn"
                                    style={{
                                        marginTop: "-50px",
                                        fontSize: "20px",
                                        position: "sticky",
                                        border: 0,
                                    }}
                                    onClick={() => setHide(null)}
                                >
                                    <span>×</span>
                                </button>
                            </div>
                        </Col>
                        <Col lg={12} style={{ borderTop: "1px solid #cacaca" }}>
                            <Row>
                                <Col
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    style={{
                                        marginTop: "10px",
                                    }}
                                >
                                    <Row
                                        style={{ backgroundColor: "#f8f9fa00" }}
                                        className="mt-3"
                                    >
                                        <Col lg={1}></Col>
                                        <Col
                                            lg={10}
                                            md={10}
                                            sm={10}
                                            style={{ marginLeft: "10px" }}
                                        >
                                            <Row>
                                                <Col lg={6} md={12} sm={12}>
                                                     
                                                    <Row style={{ marginTop: "10px" }}>
                                                        <Col lg={2}>
                                                            <button
                                                                className="btn btn-primary"
                                                                disabled
                                                                style={{
                                                                    padding: "0.05rem 0.5rem",
                                                                    backgroundColor: "grey",
                                                                    borderColor: "grey",
                                                                }}
                                                            >
                                                                {details?.invoice_status}
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: "15px" }}>
                                                        <Col lg={6} md={12} sm={12}>
                                                            <b>Invoice Amount</b>
                                                        </Col>
                                                        <Col lg={6} md={5} sm={12}>
                                                             {details?.grand_total}
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: "15px" }}>
                                                        <Col lg={6} md={12} sm={12}>
                                                            <b>Invoice No.</b>
                                                        </Col>
                                                        <Col lg={6} md={5} sm={12}>
                                                             {details?.invoice_no}
                                                        </Col>
                                                    </Row>

                                                    <Row style={{ marginTop: "15px" }}>
                                                        <Col lg={6} md={12} sm={12}>
                                                            <b>PLACE OF SUPPLY</b>
                                                        </Col>
                                                        <Col lg={6} md={5} sm={12}>
                                                        {details?.supply_state?.state_name}
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: "15px" }}>
                                                        <Col lg={6} md={12} sm={12}>
                                                            <b>DATE</b>
                                                        </Col>
                                                        <Col lg={6} md={5} sm={12}>
                                                            {details?.invoice_date ? moment(details?.invoice_date).format("DD-MMM-YYYY").replace(/^\-/, "") : ""}
                                                        </Col>
                                                    </Row>

                                                    <Row style={{ marginTop: "40px" }}>
                                                        <Col lg={12}>
                                                        <text
                                                            style={{
                                                            fontSize: "20px",
                                                            color: "black",
                                                            marginTop: "20px",
                                                            }}
                                                        >
                                                            ATTACHEMENTS
                                                        </text>
                                                        {details?.files
                                                            ?.length > 0 ? (
                                                                details?.files?.map(
                                                            (file, i) => {
                                                                return (
                                                                <Col
                                                                    key={file?.file?.id}
                                                                    lg={12}
                                                                    style={{ marginBottom: "20px" }}
                                                                >
                                                                    <hr></hr>
                                                                    <div>
                                                                    <b>{file?.file?.file_name}</b>{" "}
                                                                    &nbsp;
                                                                    <a
                                                                        href={file?.file?.file_url}
                                                                        target="_blank"
                                                                        download={file?.file?.file_name}
                                                                    >
                                                                        <i className="ti-download" />
                                                                        Download
                                                                    </a>
                                                                    </div>
                                                                </Col>
                                                                )
                                                            }
                                                            )
                                                        ) : (
                                                            <text style={{ marginBottom: "20px" }}>
                                                            {" "}
                                                            No Attachement Found.
                                                            </text>
                                                        )}
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: "40px" }}>
                                                    <Col lg={12}>
                                                        <p
                                                        style={{
                                                            fontSize: "20px",
                                                            color: "black",
                                                            marginTop: "20px",
                                                        }}
                                                        >
                                                        Payment
                                                        </p>

                                                        {details?.payment != null ? (
                                                        <div style={{ marginBottom: "20px" }}>
                                                            <table className="table mb-0">
                                                            <tbody>
                                                                <tr>
                                                                <th>Invoice Amount</th>
                                                                <td>{details.payment.org_v_invoice_amount}</td>
                                                                </tr>
                                                                <tr>
                                                                <th>Paid Amount</th>
                                                                <td>{details.payment.org_v_paid_amount}</td>
                                                                </tr>
                                                                <tr>
                                                                <th>Due Amount</th>
                                                                <td>{details.payment.due_amount}</td>
                                                                </tr>
                                                                <tr>
                                                                <th>Payment Reference</th>
                                                                <td>{details.payment?.org_payment?.payment_ref}</td>
                                                                </tr>
                                                                <tr>
                                                                <th>Payment Mode</th>
                                                                <td>{details.payment?.org_payment?.payment_mode}</td>
                                                                </tr>
                                                                <tr>
                                                                <th>Status</th>
                                                                <td>{details.payment.status.replace(/_/g, ' ')}</td>
                                                                </tr>
                                                                <tr>
                                                                <th>Payment Date</th>
                                                                <td> 
                                                                {new Date(details.payment?.org_payment?.payment_date).toLocaleDateString('en-GB', {
                                                                    day: '2-digit',month: 'short',year: 'numeric'}).replace(/ (\w{3}) /, ' $1, ')}</td>
                                                                </tr> 
                                                            </tbody>
                                                            </table>
                                                        </div>
                                                        ) : (
                                                        <p style={{ marginBottom: "20px" }}>No Payment Found.</p>
                                                        )}
                                                    </Col>
                                                    </Row>
                                                </Col>
                                                <Col lg={1}></Col>
                                                 
                                            </Row>
                                             
                                        </Col>
                                        <Col lg={1}></Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Spin>
    )
}
InvoiceDetails.propTypes = {
    t: PropTypes.any,
}

export default withRouter(withTranslation()(InvoiceDetails))
